module.exports = __webpack_public_path__ + "img/success.b959a80c.png";